import { Injectable } from '@angular/core'
import { BehaviorSubject, Subject } from 'rxjs'
import { IlmoitinVirhe, TallennaArvoBaseEvent } from '../../_jaettu-lemonator/model/kirjanpito'

@Injectable()
export class VeroilmoitusEventsService {
  private _tallennaArvoSubject = new Subject<TallennaArvoBaseEvent>()
  tallennaArvoObservable = this._tallennaArvoSubject.asObservable()

  private _ilmoitinErrorsSubject = new BehaviorSubject<IlmoitinVirhe[]>([])
  ilmoitinErrorsObservable = this._ilmoitinErrorsSubject.asObservable()

  emit(event: TallennaArvoBaseEvent) {
    this._tallennaArvoSubject.next(event)
  }

  paivitaVirheet(virheet: IlmoitinVirhe[]) {
    this._ilmoitinErrorsSubject.next(virheet || [])
  }

  annaLomakeTunniste(lomake: string, numero: string): string {
    return lomake + '_' + numero
  }
}
